import React from "react";
import { Form, Col } from "react-bootstrap";

import { GroupFields } from "../../../reusableComponent";
import { GroupFieldsedit } from "../../../reusableComponent/formFields/indexedit";
import { DatePicker } from "../../../../component/DatePicker";
import { EditNonpmg } from "../../../reusableComponent/formFields/EditNonpmg";
//
import { get, isFunction } from "lodash";
import { validatePercentage } from "../../../../validation";
import { getLocalstorage } from "../../../../helper";

export class Status extends React.PureComponent {
  // eslint-disable-next-line NO-useless-constructor
  constructor(props) {
    super(props);
    this.state = {
      projectCompletionDTO: props.projectCompletionDTO || {},
      projectImplementationStartState:
        props.projectImplementationStartState || {}
    };
  }

  static getDerivedStateFromProps(props, state) {
    return { projectCompletionDTO: props.projectCompletionDTO };
  }

  onChange = e => {
    const {
      onChange,
      projectCompletionDTO,
      updateParentStateError,
      isEdit,
      onFinancialProgressChange
    } = this.props;
    //console.log(projectCompletionDTO)
    const {
      dataset: { key },
      value
    } = e.target;

    let regex = /([^0-9.])/gi;
    let regexSuccess = regex.test(value);
    if (key === "percentage" && regexSuccess === true) {
      return;
    }

    if (key === "percentage") {
      let percentageErr = {};
      percentageErr = validatePercentage(value, false, false, key);
      updateParentStateError("percentage", percentageErr);
    }

    let newObj;

    if (isEdit) {
      let tempObj = {};
      //console.log(isEdit)
      if (
        value === "underConstruction" &&
        projectCompletionDTO &&
        (projectCompletionDTO.status === "provisionallyCommissioned" ||
          projectCompletionDTO.status === "PROVISIONALLY_COMMISSIONED")
      ) {
        tempObj.date =
          projectCompletionDTO && projectCompletionDTO.physicalProgressAsOf
            ? projectCompletionDTO.physicalProgressAsOf
            : null;
      }
      if (
        value === "projectPhysicallyCompleted" &&
        projectCompletionDTO &&
        (projectCompletionDTO.status === "commissioned" ||
          projectCompletionDTO.status === "COMMISSIONED")
      ) {
        tempObj.date =
          projectCompletionDTO && projectCompletionDTO.physicalProgressAsOf
            ? projectCompletionDTO.physicalProgressAsOf
            : null;
      }
      if (
        value === "commissioned" &&
        projectCompletionDTO &&
        (projectCompletionDTO.status === "PHYSICALLY COMPLETED" ||
          projectCompletionDTO.status === "projectPhysicallyCompleted")
      ) {
        tempObj.physicalProgressAsOf =
          projectCompletionDTO && projectCompletionDTO.date
            ? projectCompletionDTO.date
            : null;
        tempObj.date = null;
      }
      if (
        value === "provisionallyCommissioned" &&
        projectCompletionDTO &&
        (projectCompletionDTO.status === "UNDER CONSTRUCTION" ||
          projectCompletionDTO.status === "underConstruction")
      ) {
        tempObj.physicalProgressAsOf =
          projectCompletionDTO && projectCompletionDTO.date
            ? projectCompletionDTO.date
            : null;
        tempObj.date = null;
      }

      newObj =
        key === "status" &&
        (projectCompletionDTO && !projectCompletionDTO.status)
          ? { [key]: value, percentage: "", date: "" }
          : { ...projectCompletionDTO, [key]: value, ...tempObj };
    } else {
      newObj =
        (key === "status" &&
          (projectCompletionDTO && !projectCompletionDTO.status)) ||
        (key === "status" &&
          projectCompletionDTO &&
          projectCompletionDTO.status !== value)
          ? { [key]: value, percentage: "", date: "", financialPercentage: "" }
          : { ...projectCompletionDTO, [key]: value };
      //console.log(newObj)
      if (
        newObj.status == "projectPhysicallyCompleted" ||
        newObj.status == "commissioned"
      ) {
        newObj =
          (key === "status" &&
            (projectCompletionDTO && !projectCompletionDTO.status)) ||
          (key === "status" &&
            projectCompletionDTO &&
            projectCompletionDTO.status !== value)
            ? {
                [key]: value,
                percentage: 100,
                date: "",
                financialPercentage: ""
              }
            : { ...projectCompletionDTO, [key]: value };
      } else {
        newObj =
          (key === "status" &&
            (projectCompletionDTO && !projectCompletionDTO.status)) ||
          (key === "status" &&
            projectCompletionDTO &&
            projectCompletionDTO.status !== value)
            ? {
                [key]: value,
                percentage: "",
                date: "",
                financialPercentage: ""
              }
            : { ...projectCompletionDTO, [key]: value };
      }
    }

    //console.log(projectCompletionDTO)
    isFunction(onChange) &&
      onChange(newObj) &&
      onFinancialProgressChange(newObj);
  };

  onFinancialProgressChange = e => {
    //console.log(e.target.value)
    const {
      onChange,
      updateParentStateError,
      projectCompletionDTO
    } = this.props;
    //console.log(projectCompletionDTO)
    const {
      dataset: { key },
      value
    } = e.target;
    let regex = /([^0-9.])/gi;
    let regexSuccess = regex.test(value);
    if (key === "financialPercentage" && regexSuccess === true) {
      return;
    }

    let financialPercentageErr = {};
    if (key === "financialPercentage") {
      financialPercentageErr = validatePercentage(value, true);
    } else {
      financialPercentageErr = {
        error: false
      };
    }

    updateParentStateError("financialPercentage", financialPercentageErr);
    const newObj = { ...projectCompletionDTO, [key]: value };
    //console.log(newObj)
    isFunction(onChange) && onChange(newObj);
  };

  onSelectDate = value => {
    //console.log(value)
    const {
      onChange,
      projectCompletionDTO,
      updateParentStateError
    } = this.props;
    const newObj = { ...projectCompletionDTO, date: value };
    updateParentStateError("date", {});
    //console.log(newObj)
    isFunction(onChange) && onChange(newObj);
  };

  onSelectPhysicalProgressDate = value => {
    const {
      onChange,
      projectCompletionDTO,
      updateParentStateError,
      progressAsofDateErr
    } = this.props;
    const newObj = {
      ...projectCompletionDTO,
      physicalProgressAsOf: value
    };
    //console.log(progressAsofDateErr)
    updateParentStateError("progressAsof", {});
    isFunction(onChange) && onChange(newObj);
  };

  onClear = () => {
    const { onChange } = this.props;
    isFunction(onChange) && onChange({});
  };

  validateDecimalValue = e => {
    let targetValue = e.target.value;
    e.target.value =
      targetValue.indexOf(".") >= 0
        ? targetValue.slice(0, targetValue.indexOf(".") + 3)
        : targetValue;
  };

  render() {
    const {
      onChange,
      onFinancialProgressChange,
      onSelectDate,
      onSelectPhysicalProgressDate,
      props: {
        error,
        options = [],
        disabledFields = {},
        percentageErr,
        financialPercentageErr,
        dateErr,
        progressAsofDateErr,
        projectStatus = "",
        isRequired,
        isIIGProjectEdit = false,
        isEdit,
        iigProjectReferenceId,
        isFormTypeNotDefault,
        projectstageerror,
        projectCategoryId,
        isUPproject
      }
    } = this;
    const isIIGDraft = projectStatus === "CRIP_DRAFT";
    const userInfo = getLocalstorage("user");
    const {
      projectCompletionDTO,
      projectImplementationStartState
    } = this.state;
    const {
      status,
      date,
      percentage,
      physicalProgressAsOf,
      financialPercentage
    } = projectCompletionDTO || {};
    const {
      date: dateDisabled,
      percentage: percentageDisabled
    } = disabledFields;
    return (
      <>
        <Form.Group className="stage">
          <Form.Label
            data-test="label-project-status"
            className={
              projectCategoryId == "STATE" ? "project-cost-share-text" : null
            }
          >
            Project Status
            {projectImplementationStartState == "UNDER_IMPLEMENTATION" ||
            projectImplementationStartState == "COMPLETED" ? (
              <>
                <span className="required">*</span>
              </>
            ) : null}
          </Form.Label>
          <div className="form-field form-field-data">
            <Form.Group
              className={`field-mscb ${
                error && error.error && options.length > 1 && isRequired
                  ? "error-field"
                  : ""
              }`}
            >
              {isEdit == undefined ? (
                <>
                  <GroupFields
                    name="status"
                    keyName="status"
                    options={options}
                    events={{
                      onChange: onChange
                    }}
                  />
                </>
              ) : (
                <></>
              )}
              {isEdit == true && isFormTypeNotDefault == undefined ? (
                <>
                  <GroupFieldsedit
                    name="status"
                    keyName="status"
                    options={options}
                    events={{
                      onChange: onChange
                    }}
                    isFormTypeNotDefault={isFormTypeNotDefault}
                  />
                </>
              ) : (
                <></>
              )}
              {isEdit == true && isFormTypeNotDefault == true ? (
                <>
                  <EditNonpmg
                    name="status"
                    keyName="status"
                    options={options}
                    events={{
                      onChange: onChange
                    }}
                    isFormTypeNotDefault={isFormTypeNotDefault}
                  />
                </>
              ) : (
                <></>
              )}
            </Form.Group>

            {status ||
            projectImplementationStartState === "IMPLEMENTATION_NOT_STARTED" ? (
              <React.Fragment>
                <Form.Row
                  className="make-col "
                  style={{
                    marginTop:
                      // projectImplementationStartState ==
                      // "IMPLEMENTATION_NOT_STARTED"
                      //   ? "-1%"
                      //   :
                      "1%"
                  }}
                >
                  {projectImplementationStartState == "UNDER_IMPLEMENTATION" ? (
                    <Form.Group className="field-mscb col-6">
                      <Form.Label data-test="label-physical-progress">
                        Physical Progress %
                      </Form.Label>
                      <Form.Control
                        data-test="physical-progress"
                        data-key="percentage"
                        type="text"
                        placeholder="Please enter percentage"
                        onChange={onChange}
                        onInput={this.validateDecimalValue}
                        value={percentage}
                        disabled={isUPproject}
                        className={
                          (percentageErr && percentageErr.error) ||
                          (!percentage &&
                            isRequired &&
                            isEdit &&
                            userInfo.groupCategory === "PP")
                            ? "is-invalid"
                            : ""
                        }
                      />
                      {(percentageErr && percentageErr.error) ||
                      (projectCompletionDTO.percentage < 0 ||
                        projectCompletionDTO.percentage >= 100) ? (
                        <div className="error-field error-message">
                          {percentageErr && percentageErr.message && (
                            <i>{percentageErr.message}</i>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </Form.Group>
                  ) : null}
                  {(projectImplementationStartState == "COMPLETED" &&
                    status == "commissioned") ||
                  status == "projectPhysicallyCompleted" ||
                  status == "PHYSICALLY COMPLETED/CC UNDER ISSUE" ||
                  status === "COMMISSIONED" ? (
                    <Form.Group className="field-mscb col-6">
                      <Form.Label data-test="label-physical-progress">
                        Physical Progress %
                      </Form.Label>
                      <Form.Control
                        data-test="physical-progress"
                        data-key="percentage"
                        type="text"
                        onChange={onChange}
                        onInput={this.validateDecimalValue}
                        value={percentage}
                        disabled
                      />
                    </Form.Group>
                  ) : null}
                  {projectImplementationStartState ==
                    "IMPLEMENTATION_NOT_STARTED" ||
                  projectImplementationStartState == "UNDER_IMPLEMENTATION" ||
                  (projectImplementationStartState == "COMPLETED" &&
                    status == "commissioned") ||
                  status == "projectPhysicallyCompleted" ||
                  status === "COMMISSIONED" ||
                  status == "PHYSICALLY COMPLETED/CC UNDER ISSUE" ? (
                    <Form.Group className="field-mscb col-6">
                      <Form.Label data-test="label-financial-progress">
                        Financial Progress %
                      </Form.Label>
                      <Form.Control
                        disabled={
                          isIIGDraft ||
                          isIIGProjectEdit ||
                          iigProjectReferenceId ||
                          isUPproject
                        }
                        data-test="financial-progress"
                        data-key="financialPercentage"
                        type="text"
                        placeholder="Please enter percentage"
                        onChange={onFinancialProgressChange}
                        value={financialPercentage}
                        onInput={this.validateDecimalValue}
                        className={
                          financialPercentageErr && financialPercentageErr.error
                            ? "is-invalid"
                            : projectImplementationStartState ==
                              "IMPLEMENTATION_NOT_STARTED"
                            ? "height-fix-finance"
                            : ""
                        }
                      />
                      {financialPercentageErr &&
                      financialPercentageErr.message ? (
                        <div className="error-field error-message">
                          <i>{financialPercentageErr.message}</i>
                        </div>
                      ) : (
                        ""
                      )}
                    </Form.Group>
                  ) : null}
                  {projectImplementationStartState ==
                  "IMPLEMENTATION_NOT_STARTED" ? (
                    <Form.Group
                      as={Col}
                      className="field-mscb field-datepicker"
                    >
                      <Form.Label data-test="label-progress-as-of">
                        Progress As of
                      </Form.Label>
                      <div
                        data-test="progress-as-of"
                        style={{ fontWeight: "normal" }}
                      >
                        <DatePicker
                          data-key="date"
                          onChange={onSelectPhysicalProgressDate}
                          selected={physicalProgressAsOf}
                          value={physicalProgressAsOf}
                          maxDate={new Date()}
                          isClearable={
                            physicalProgressAsOf &&
                            !isIIGDraft &&
                            !isIIGProjectEdit &&
                            iigProjectReferenceId === null &&
                            !isUPproject
                          }
                          disabled={
                            dateDisabled ||
                            isIIGDraft ||
                            isIIGProjectEdit ||
                            iigProjectReferenceId ||
                            isUPproject
                          }
                          className={`data-test-class-progress-as-of pragati-date physicalProgressAsOf status-date-box ${
                            get(progressAsofDateErr, "error") && isRequired
                              ? "error-field-set"
                              : ""
                          }`}
                        />
                        {progressAsofDateErr &&
                        progressAsofDateErr.message &&
                        isRequired ? (
                          <div className="error-field error-message">
                            <i>{progressAsofDateErr.message}</i>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </Form.Group>
                  ) : null}
                </Form.Row>
                {(projectImplementationStartState == "COMPLETED" &&
                  status === "commissioned") ||
                status === "COMMISSIONED" ? (
                  <Form.Row
                    className="make-col progress-in-project-form "
                    style={{ marginTop: "1%" }}
                  >
                    <Form.Group as={Col} className="field-mscb">
                      <Form.Label data-test="label-progress-as-of">
                        Commissioning Date
                      </Form.Label>
                      <div
                        data-test="progress-as-of"
                        style={{ fontWeight: "normal" }}
                      >
                        <DatePicker
                          data-key="date"
                          onChange={onSelectDate}
                          selected={date}
                          value={date}
                          maxDate={new Date()}
                          isClearable={
                            date &&
                            !isIIGDraft &&
                            !isIIGProjectEdit &&
                            !iigProjectReferenceId &&
                            !isUPproject
                          }
                          disabled={
                            dateDisabled ||
                            isIIGDraft ||
                            isIIGProjectEdit ||
                            iigProjectReferenceId ||
                            isUPproject
                          }
                          className={`data-test-class-date-field pragati-date status-date-box ${
                            get(dateErr, "error") ? "error-field-set" : ""
                          }`}
                        />
                        {dateErr && dateErr.message ? (
                          <div className="error-field error-message">
                            <i>{dateErr.message}</i>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </Form.Group>
                  </Form.Row>
                ) : null}

                {projectImplementationStartState == "UNDER_IMPLEMENTATION" &&
                (status === "underConstruction" ||
                  status == "UNDER CONSTRUCTION") ? (
                  <Form.Row
                    className="make-col progress-in-project-form "
                    style={{ marginTop: "1%" }}
                  >
                    <Form.Group as={Col} className="field-mscb">
                      <Form.Label
                        data-test={
                          /Construction/gi.test(status)
                            ? "label-progress-as-of"
                            : /Partially/gi.test(status)
                            ? "label-partially-commissioned-date"
                            : "label-commissioned-date"
                        }
                      >
                        {/Construction/gi.test(status)
                          ? "Progress As of"
                          : /Partially/gi.test(status)
                          ? "Provisional Commissioning Date"
                          : "Commissioned Date"}
                      </Form.Label>
                      <div
                        data-test={
                          /Construction/gi.test(status)
                            ? "progress-as-of"
                            : /Partially/gi.test(status)
                            ? "partially-commissioned-date"
                            : "commissioned-date"
                        }
                        style={{ fontWeight: "normal" }}
                      >
                        <DatePicker
                          data-key="date"
                          onChange={onSelectDate}
                          selected={date}
                          value={date}
                          maxDate={new Date()}
                          isClearable={
                            date &&
                            !isIIGDraft &&
                            !isIIGProjectEdit &&
                            !iigProjectReferenceId &&
                            !isUPproject
                          }
                          disabled={
                            dateDisabled ||
                            isIIGDraft ||
                            isIIGProjectEdit ||
                            iigProjectReferenceId ||
                            isUPproject
                          }
                          className={`data-test-class-date-field pragati-date status-date-box ${
                            get(dateErr, "error") ? "error-field-set" : ""
                          }`}
                        />
                        {dateErr && dateErr.message ? (
                          <div className="error-field error-message">
                            <i>{dateErr.message}</i>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </Form.Group>
                  </Form.Row>
                ) : null}
                {(projectImplementationStartState == "UNDER_IMPLEMENTATION" &&
                  status === "provisionallyCommissioned") ||
                status == "PROVISIONALLY COMMISSIONED" ? (
                  <Form.Row
                    className="make-col progress-in-project-form "
                    style={{
                      marginTop: "1%",
                      fontSize: isFormTypeNotDefault == true ? 14 : null
                    }}
                  >
                    <Form.Group className="field-mscb col-6">
                      <Form.Label data-test="label-progress-as-of">
                        Progress As of
                      </Form.Label>
                      <div
                        data-test="progress-as-of"
                        style={{ fontWeight: "normal" }}
                      >
                        <DatePicker
                          data-key="date"
                          onChange={onSelectPhysicalProgressDate}
                          selected={physicalProgressAsOf}
                          value={physicalProgressAsOf}
                          maxDate={new Date()}
                          isClearable={
                            physicalProgressAsOf &&
                            !isIIGDraft &&
                            !isIIGProjectEdit &&
                            iigProjectReferenceId === null &&
                            !isUPproject
                          }
                          disabled={
                            dateDisabled ||
                            isIIGDraft ||
                            isIIGProjectEdit ||
                            iigProjectReferenceId ||
                            isUPproject
                          }
                          className={`data-test-class-progress-as-of pragati-date physicalProgressAsOf status-date-box ${
                            get(progressAsofDateErr, "error") && isRequired
                              ? "error-field-set"
                              : ""
                          }`}
                        />
                        {progressAsofDateErr &&
                        progressAsofDateErr.message &&
                        isRequired ? (
                          <div className="error-field error-message">
                            <i>{progressAsofDateErr.message}</i>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </Form.Group>
                    <Form.Group className="field-mscb col-6">
                      <Form.Label
                        data-test={
                          /Construction/gi.test(status)
                            ? "label-progress-as-of"
                            : /Partially/gi.test(status)
                            ? "label-partially-commissioned-date"
                            : "label-commissioned-date"
                        }
                      >
                        {/Construction/gi.test(status)
                          ? "Progress As of"
                          : /Partially/gi.test(status)
                          ? "Provisional Commissioning Date"
                          : "Provisional Commissioning Date"}
                      </Form.Label>
                      <div
                        data-test={
                          /Construction/gi.test(status)
                            ? "progress-as-of"
                            : /Partially/gi.test(status)
                            ? "partially-commissioned-date"
                            : "commissioned-date"
                        }
                        style={{ fontWeight: "normal" }}
                      >
                        <DatePicker
                          data-key="date"
                          onChange={onSelectDate}
                          selected={date}
                          value={date}
                          maxDate={new Date()}
                          isClearable={
                            date &&
                            !isIIGDraft &&
                            !isIIGProjectEdit &&
                            !iigProjectReferenceId &&
                            !isUPproject
                          }
                          disabled={
                            dateDisabled ||
                            isIIGDraft ||
                            isIIGProjectEdit ||
                            iigProjectReferenceId ||
                            isUPproject
                          }
                          className={`data-test-class-date-field pragati-date status-date-box ${
                            get(dateErr, "error") ? "error-field-set" : ""
                          }`}
                        />
                        {dateErr && dateErr.message ? (
                          <div className="error-field error-message">
                            <i>{dateErr.message}</i>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </Form.Group>
                  </Form.Row>
                ) : null}
                {(projectImplementationStartState == "COMPLETED" &&
                  status == "projectPhysicallyCompleted") ||
                status == "PHYSICALLY COMPLETED/CC UNDER ISSUE" ? (
                  <Form.Row
                    className="make-col progress-in-project-form "
                    style={{ marginTop: "1%" }}
                  >
                    <Form.Group className="field-mscb col-6">
                      <Form.Label data-test="label-progress-as-of">
                        Progress As of
                      </Form.Label>
                      <div
                        data-test="progress-as-of"
                        style={{ fontWeight: "normal" }}
                      >
                        <DatePicker
                          data-key="date"
                          onChange={onSelectPhysicalProgressDate}
                          selected={physicalProgressAsOf}
                          value={physicalProgressAsOf}
                          maxDate={new Date()}
                          isClearable={
                            physicalProgressAsOf &&
                            !isIIGDraft &&
                            !isIIGProjectEdit &&
                            iigProjectReferenceId === null &&
                            !isUPproject
                          }
                          disabled={
                            dateDisabled ||
                            isIIGDraft ||
                            isIIGProjectEdit ||
                            iigProjectReferenceId ||
                            isUPproject
                          }
                          className={`data-test-class-progress-as-of pragati-date physicalProgressAsOf status-date-box ${
                            get(progressAsofDateErr, "error") && isRequired
                              ? "error-field-set"
                              : ""
                          }`}
                        />
                        {typeof progressAsofDateErr !== "undefined" &&
                        progressAsofDateErr.message &&
                        isRequired ? (
                          <div className="error-field error-message">
                            <i>{progressAsofDateErr.message}</i>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </Form.Group>

                    <Form.Group className="field-mscb col-6">
                      <Form.Label>Physical Completion Date</Form.Label>
                      <div style={{ fontWeight: "normal" }}>
                        <DatePicker
                          data-key="date"
                          onChange={onSelectDate}
                          selected={date}
                          value={date}
                          maxDate={new Date()}
                          isClearable={
                            date &&
                            !isIIGDraft &&
                            !isIIGProjectEdit &&
                            !iigProjectReferenceId &&
                            !isUPproject
                          }
                          disabled={
                            dateDisabled ||
                            isIIGDraft ||
                            isIIGProjectEdit ||
                            iigProjectReferenceId ||
                            isUPproject
                          }
                          className={`data-test-class-date-field pragati-date status-date-box ${
                            get(dateErr, "error") ? "error-field-set" : ""
                          }`}
                        />
                        {dateErr && dateErr.message ? (
                          <div className="error-field error-message">
                            <i>{dateErr.message}</i>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </Form.Group>
                  </Form.Row>
                ) : null}
              </React.Fragment>
            ) : null}
            {error && error.message && isRequired ? (
              <div className="error-field error-message">
                <i>{error.message}</i>
              </div>
            ) : (
              ""
            )}
          </div>
        </Form.Group>
      </>
    );
  }
}
